import { api, getBaseUrl } from "./_ApiFactoryWithHeader";

export const apiTenant = {
    getTenants: (params) => {
        return api.get('tenants', params, null)
    },
    getTenantDetail: (id, params) => {
        return api.get(`tenants/${encodeURIComponent(id)}`, params, null)
    },
    addTenant: (body) => {
        return api.post(`tenants`, body)
    },
    updateTenant: (id, body) => {
        return api.put(`tenants/${encodeURIComponent(id)}`, body)
    },
    fullUpdateTenant: (id, body, params) => {
        let url = `tenants/${encodeURIComponent(id)}`;
        if (params) {
            const queryParams = new URLSearchParams(params);
            url += '?' + queryParams;
        }
        return api.post(url, body);
    },
    deleteTenant: (id, params) => {
        return api.delete(`tenants/${encodeURIComponent(id)}`, params);
    },
    getAuctions: (params) => {
        return api.get('auction_slots', params, null)
    },
    getTenantMembers: (params) => {
        return api.get(`tenant_members`, params, null)
    },
    getTenantMemberDetail: (id, params) => {
        return api.get(`tenant_members/${encodeURIComponent(id)}`, params, null)
    },
    addTenantMember: (body) => {
        return api.post(`tenant_members`, body)
    },
    updateTenantMember: (id, body) => {
        return api.put(`tenant_members/${encodeURIComponent(id)}`, body)
    },
    fullUpdateTenantMember: (id, body, params) => {
        let url = `tenant_members/${encodeURIComponent(id)}`;
        if (params) {
            const queryParams = new URLSearchParams(params);
            url += '?' + queryParams;
        }
        return api.post(url, body);
    },
    deleteTenantMember: (id, params) => {
        return api.delete(`tenant_members/${encodeURIComponent(id)}`, params);
    },
    getTenantMemberRoles: (params) => {
        return api.get(`tenant_member_roles`, params, null)
    },
    getAuctionDetail: (id, params) => {
        return api.get(`auction_slots/${encodeURIComponent(id)}`, params, null)
    },
    addAuction: (body) => {
        return api.post(`auction_slots`, body)
    },
    updateAuction: (id, body) => {
        return api.put(`auction_slots/${encodeURIComponent(id)}`, body)
    },
    updateAuctionStatus: (id, body) => {
        return api.put(`auction_slot_status_update/${encodeURIComponent(id)}`, body)
    },
    deleteAuction: (id, params) => {
        return api.delete(`auction_slots/${encodeURIComponent(id)}`, params);
    },
    submitSealedBid: (platform, id, body) => {
        return api.post(`${getBaseUrl(platform)}/submit_final_sealed_bid/${encodeURIComponent(id)}`, body);
    },
    downloadSealedBidInfo: (platform, id, option) => {
        return api.getCSVFile(`${getBaseUrl(platform)}/download_sealed_bid_info/${encodeURIComponent(id)}`, { responseType: 'blob', ...option });
    },
    uploadSealedBidInfo: (platform, id, body) => {
        return api.postMultipart(`${getBaseUrl(platform)}/upload_sealed_bid_info/${encodeURIComponent(id)}`, body, {});
    },
    completeSealedBidAward: (platform, id, body) => {
        return api.post(`${getBaseUrl(platform)}/complete_sealed_bid_award/${encodeURIComponent(id)}`, body);
    },
    getSuppliers: (params) => {
        return api.get('suppliers', params, null);
    },
    getLots: (platform, params) => {
        return api.get(`${getBaseUrl(platform)}/auctions`, params, null);
    },
};
